import {findEnumByEnumObject} from '@/services/enumTranslator/FindEnumByEnumObject';
import {normalizeNumberEnum} from '@/services/enumTranslator/normalizeNumberEnum';

export function findEnumByKeys<TEnum extends string>(enumObject: Record<keyof TEnum, TEnum>, value: TEnum): string {
  // const data: Partial<Record<keyof TEnum, TEnum>> = normalizeNumberEnum(enumObject);
  return findEnumByEnumObject<TEnum>(enumObject)[value];
}
